module.exports = __webpack_public_path__ + "public/img/saomahexiao.dd8e5d27.png";